import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface FeeState {
  feeGroups: ServiceFeeGroup[];
  currentFeeGroup: ServiceFeeGroup | null;
  feeScales: ServiceFeeScale[];
}

const initialState: FeeState = {
  feeGroups: [],
  feeScales: [],
  currentFeeGroup: null,
};

const feeSlices = createSlice({
  name: "feeSlices",
  initialState,
  reducers: {
    setFeeGroups: (state, action: PayloadAction<ServiceFeeGroup[]>) => {
      state.feeGroups = action.payload;
    },
    setFeeScales: (state, action: PayloadAction<ServiceFeeScale[]>) => {
      state.feeScales = action.payload;
    },
    setCurrentFeeGroup: (state, action: PayloadAction<ServiceFeeGroup>) => {
      state.currentFeeGroup = action.payload;
    },
  },
});

export const feeActions = feeSlices.actions;
export default feeSlices.reducer;
